import { routes as financePrintsRoutes } from "./prints/routes";
import { routes as supplierPrintsRoutes } from "./consultant-supplier/supplier/routes";
export const routes = (prefix = `finance-dashboard`) => [
    {
        path: `/${prefix}/bill-payments/create`,
        name: `${prefix}.bill-payments.create`,
        component: () => import('./consultant-supplier/Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.bill-payments.create`,
                PageDescription: "Finance: Bill Payment (Supplier and Consultants)",
            },
        },
    },
    {
        path: `/${prefix}/bill-payments`,
        name: `${prefix}.bill-payments.index`,
        component: () => import('./consultant-supplier/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.bill-payments.create`,
                PageDescription: "Finance: Bill Payment (Supplier and Consultants)",
            },
        },
    },
    ...financePrintsRoutes(),
    ...supplierPrintsRoutes(),
];
